import { MouseEventDispatcher } from "../MouseEventDispatcher";

import { objectsUnderPoint } from "./objectsUnderPoint";
import { CREATEJS_UTILITIES_LOGGER } from "../../../../..";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger(CREATEJS_UTILITIES_LOGGER + ".StageExtension");

Object.defineProperty(createjs.Stage.prototype, "frameRate", {
    get: function(): number {
        return createjs.Ticker.framerate;
    },
    set: function(value: number) {
        createjs.Ticker.framerate = value;
    },
    enumerable: true,
    configurable: true
});

createjs.Stage.prototype.invalidate = function() {
    // to be implemented
};

/**
 * @method _testMouseOver This function is copied directly from createjs, so that _getObjectUnderPoint() will use our own one
 * @param {Boolean} clear If true, clears the mouseover / rollover (ie. no target)
 * @param {Stage} owner Indicates that the event has already been captured & handled by the indicated stage.
 * @param {Stage} eventTarget The stage that the cursor is actively over.
 * @protected
 **/
createjs.Stage.prototype._testMouseOver = function(this: createjs.Stage & any, clear: boolean, owner: createjs.Stage, eventTarget: createjs.Stage) {
    if (this._prevStage && owner === undefined) { return; } // redundant listener.

    const nextStage: createjs.Stage | undefined = this._nextStage;

    const o = this._getPointerData(-1);
    // only update if the mouse position has changed. This provides a lot of optimization, but has some trade-offs.
    if (!o || (!clear && this.mouseX === this._mouseOverX && this.mouseY === this._mouseOverY && this.mouseInBounds)) { return; }

    const e = o.posEvtObj;
    const isEventTarget = eventTarget || e && (e.target === this.canvas);
    let target = null, common = -1, cursor = "";


    if (!owner && (clear || this.mouseInBounds && isEventTarget)) {
        let restrictedInteractiveArea = (window as any).restrictedInteractiveArea;
        if (restrictedInteractiveArea) {
            if (Array.isArray(restrictedInteractiveArea) && restrictedInteractiveArea.length) {
                for (let j = restrictedInteractiveArea.length - 1; j >= 0; j--) {
                    let restrict = restrictedInteractiveArea[j];
                    if (!restrict) { continue; }
                    let r = restrict instanceof createjs.Container ? restrict : restrict.parent;
                    if (!r) { continue; }
                    target = this._getObjectsUnderPoint.call(r, this.mouseX, this.mouseY, null, true, null, 8);
                    if ( target ) { break; }
                }
            } else if (restrictedInteractiveArea instanceof createjs.DisplayObject) {

            restrictedInteractiveArea = restrictedInteractiveArea instanceof createjs.Container ?
                                            restrictedInteractiveArea : restrictedInteractiveArea.parent;
            if (!restrictedInteractiveArea) {
                return;
            }
            // use 8 to simulate deeper layer, so that we can skip with getBounds
            target = this._getObjectsUnderPoint.call(restrictedInteractiveArea, this.mouseX, this.mouseY, null, true, null, 8);
            }
        } else {
            target = this._getObjectsUnderPoint(this.mouseX, this.mouseY, null, true);
        }
        MouseEventDispatcher.setTarget(target);
        if ((window as any).cursorDebug) {
            if (target) {
                logger.info("found hit target: ", target);
            } else {
                logger.warn("found nothing under cursor");
            }
        }
        this._mouseOverX = this.mouseX;
        this._mouseOverY = this.mouseY;
    }

    let oldList = this._mouseOverTarget || [];
    let oldTarget = oldList[oldList.length - 1];
    let list: any[] = this._mouseOverTarget = [];

    // generate ancestor list and check for cursor:
    {
        let t = target;
        while (t) {
            list.unshift(t);
            t = t.parent;
        }
    }

    // find common ancestor:
    for (let i = 0, l = list.length; i < l; i++) {
        if (list[i] !== oldList[i]) { break; }
        common = i;
    }

    if (oldTarget !== target) {
        this._dispatchMouseEvent(oldTarget, "mouseout", true, -1, o, e, target);
    }

    for (let i = oldList.length - 1; i > common; i--) {
        this._dispatchMouseEvent(oldList[i], "rollout", false, -1, o, e, target);
    }

    for (let i = list.length - 1; i > common; i--) {
        this._dispatchMouseEvent(list[i], "rollover", false, -1, o, e, oldTarget);
    }

    if (oldTarget !== target) {
        this._dispatchMouseEvent(target, "mouseover", true, -1, o, e, oldTarget);
    }

    if (!target && !(window as any).restrictedInteractiveArea && nextStage) {
        nextStage._testMouseOver(clear, owner || target && this, eventTarget || isEventTarget && this);
    }
};

createjs.Stage.prototype._getObjectsUnderPoint = function(this: createjs.Stage, x: number, y: number, arr: any[] | null, mouse: boolean, activeListener?: any, currentDepth?: any): createjs.DisplayObject | null {
   return objectsUnderPoint(this, createjs.DisplayObject._hitTestContext, x, y, arr, mouse, activeListener, currentDepth);
};

/**
 * @method _updatePointerPosition
 * @protected
 * @param {Number} id
 * @param {Event} e
 * @param {Number} pageX
 * @param {Number} pageY
 **/
createjs.Stage.prototype._updatePointerPosition = function(this: createjs.Stage & any, id:number, e:createjs.Event, pageX:number, pageY:number) {
    var rect = this._getElementRect(this.canvas);
    pageX -= rect.left;
    pageY -= rect.top;

    var w = this.canvas.width / this.scaleX;
    var h = this.canvas.height / this.scaleY;
    pageX /= (rect.right-rect.left)/w;
    pageY /= (rect.bottom-rect.top)/h;
    var o = this._getPointerData(id);
    if (o.inBounds = (pageX >= 0 && pageY >= 0 && pageX <= w-1 && pageY <= h-1)) {
        o.x = pageX;
        o.y = pageY;
    } else if (this.mouseMoveOutside) {
        o.x = pageX < 0 ? 0 : (pageX > w-1 ? w-1 : pageX);
        o.y = pageY < 0 ? 0 : (pageY > h-1 ? h-1 : pageY);
    }

    o.posEvtObj = e;
    o.rawX = pageX;
    o.rawY = pageY;

    if (id === this._primaryPointerID || id === -1) {
        this.mouseX = o.x;
        this.mouseY = o.y;
        this.mouseInBounds = o.inBounds;
    }
};
